import { render } from "./KkoAuthGuidMtt.vue?vue&type=template&id=9c4fce40"
const script = {}

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__